import * as React from "react";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AuthCard, AuthDivider, LoginForm, GoogleButton } from "@/components/auth";
import { useAuth } from "@/hooks/useAuth";
import { Link } from "@tanstack/react-router";

export function LoginPage() {
  const navigate = useNavigate();
  const { signInWithGoogle, loading, user } = useAuth();
  const { t } = useTranslation("auth");

  React.useEffect(() => {
    if (user) {
      navigate({ to: "/dashboard" });
    }
  }, [user, navigate]);

  const handleSuccess = () => {
    navigate({ to: "/dashboard" });
  };

  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error("Google sign-in failed:", error);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <AuthCard
        title={t("login.title")}
        description={t("login.subtitle")}
        footer={
          <>
            {t("login.noAccount")}{" "}
            <Link to="/signup" className="font-medium text-primary hover:underline">
              {t("login.signUp")}
            </Link>
          </>
        }
      >
        <LoginForm onSuccess={handleSuccess} />
        <AuthDivider text={t("login.orContinueWith")} />
        <GoogleButton onClick={handleGoogleSignIn} loading={loading} label={t("login.google")} />
      </AuthCard>
    </div>
  );
}

export default LoginPage;
